import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { HelpPage } from "@/features/support/routes/Help";

export const Route = createLazyFileRoute("/_auth/_app/help/")({
  component: memo(HelpPage),
});
